import { Injectable } from '@angular/core';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { ResultStatus } from '../../../../../core/picks/pick-models';
import { PickResultedPreCheckError } from '../../../errors/pre-check/pick-resulted-pre-check-error';
import { IPurePickValidator } from './validators';

/**
 * Validates if the pick is not resulted.
 */
@Injectable()
export class PickResultedValidator implements IPurePickValidator<PickResultedPreCheckError> {
    validate(pick: BetslipPick): PickResultedPreCheckError[] {
        if (BetslipV1Pick.isPick(pick) && pick.resultStatus !== ResultStatus.Open) {
            return [new PickResultedPreCheckError(pick.id.toString(), pick.resultStatus)];
        }

        return [];
    }
}
